import { render, staticRenderFns } from "./NoticeboardDetail.vue?vue&type=template&id=2be45e16&scoped=true"
import script from "./NoticeboardDetail.vue?vue&type=script&lang=js"
export * from "./NoticeboardDetail.vue?vue&type=script&lang=js"
import style0 from "./NoticeboardDetail.vue?vue&type=style&index=0&id=2be45e16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be45e16",
  null
  
)

export default component.exports